<template>
    <div class="success-message">
        <el-dialog :visible.sync="dialogVisible" :show-close="true" :append-to-body="true" :close-on-click-modal="true" custom-class="success-message__dialog">
            <div class="success-message__inner">
                <div class="success-message__close" @click="closeClickHandler">
                    <Icon><IconClose/></Icon>
                </div>
                <div class="success-message__icon ui-center-content ">
                    <Icon :size="32">
                        <IconCheckGreen />
                    </Icon>
                </div>
                <div class="success-message__message copy-light">
                    {{ message }}
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import Icon from '@/components/Icon.vue'
import IconCheckGreen from '@/components/icons/IconCheckGreen.vue'
import IconClose from '@/components/icons/IconClose.vue'

export default {
    components: {
        Icon,
        IconCheckGreen,
        IconClose
    },
    data() {
        return {
            dialogVisible: false,
            message: false,
            closeAutomaticallyAfter: false
        }
    },
    computed: {
        ...mapGetters(['mobile']),
        dialogTopMargin() {
            return this.mobile ? '32px' : '64px';
        }
    },
    watch: {

    },
    mounted() {
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        closeClickHandler() {
            this.closeDialog();
        },
        showSuccessMessageHandler(e) {
            this.message = e.message
            this.closeAutomaticallyAfter = e.closeAfter
            this.showDialog()
        },
        addListeners() {
            eventBus.$on('showSuccessMessage', this.showSuccessMessageHandler);
        },
        removeListeners() {
            eventBus.$off('showSuccessMessage', this.showSuccessMessageHandler);
        },
        closeDialog() {
            this.dialogVisible = false;
            setTimeout(() => {
                this.message = false
                this.closeAutomaticallyAfter = false
            }, 500);
        },
        showDialog() {
            if(!this.message) return
            this.dialogVisible = true;

            if(this.closeAutomaticallyAfter) this.startAutomaticCloseTimer()
        },
        startAutomaticCloseTimer() {
            setTimeout(() => {
                this.closeDialog()
            }, this.closeAutomaticallyAfter);
        }
    }
}
</script>

<style lang="scss">
.success-message {
    &__dialog {
        border-radius: $standard-border-radius !important;
        max-width: 500px !important;
        width: calc(100% - 32px) !important;

        .el-dialog {
            &__header {
                display: none;
            }
            &__body {
                position: relative;
                padding: 0;
            }
        }
    }

    &__close {
        position: absolute;
        top: 16px;
        right: 16px;
        color: $color-grey-dark;
        line-height: 0;
        transition: 0.2s;
        cursor: pointer;

        .no-touch &:hover {
            color: $color-black;
        }
    }

    &__inner {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px 30px 24px;
        text-align: center;
        word-break: normal;
    }

    &__icon {
        width: 50px;
        height: 50px;
        border: 3px solid $color-green;
        border-radius: 100%;
    }

    &__message {
        margin-top: 24px;
    }
}
</style>